import MiRadio from './MiRadio.vue'

export default MiRadio
